import { render, staticRenderFns } from "./addUpdateDocument.vue?vue&type=template&id=2537f262"
import script from "./addUpdateDocument.vue?vue&type=script&lang=js"
export * from "./addUpdateDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports